import { Controller } from "@hotwired/stimulus"
import { logger } from "../utilities/logger"

// Handles copy-to-clipboard functionality for code blocks
// Slack-style with visual feedback
export default class extends Controller {
  static targets = ["buttonText"]
  static values = {
    target: String  // CSS selector for element to copy
  }

  copy(event) {
    event.preventDefault()

    // Get the target element
    const targetSelector = this.targetValue
    const targetElement = document.querySelector(targetSelector)

    if (!targetElement) {
      logger.error('Code clipboard: Target element not found:', targetSelector)
      return
    }

    // Get the text to copy
    const textToCopy = targetElement.textContent || targetElement.innerText

    // Copy to clipboard
    this.copyToClipboard(textToCopy)
      .then(() => {
        this.showSuccess()
      })
      .catch((err) => {
        logger.error('Code clipboard: Copy failed:', err)
        this.showError()
      })
  }

  async copyToClipboard(text) {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text)
      } catch (err) {
        // Fallback for older browsers
        this.fallbackCopy(text)
      }
    } else {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.position = "fixed"
    textArea.style.top = "0"
    textArea.style.left = "0"
    textArea.style.opacity = "0"
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
    } catch (err) {
      throw new Error('Fallback copy failed')
    }

    document.body.removeChild(textArea)
  }

  showSuccess() {
    if (!this.hasButtonTextTarget) return

    const originalText = this.buttonTextTarget.innerHTML

    // Show success message
    this.buttonTextTarget.innerHTML = '<i class="fas fa-check me-1"></i>הועתק!'
    this.element.classList.remove('btn-outline-secondary')
    this.element.classList.add('btn-success')

    // Revert after 2 seconds
    setTimeout(() => {
      this.buttonTextTarget.innerHTML = originalText
      this.element.classList.remove('btn-success')
      this.element.classList.add('btn-outline-secondary')
    }, 2000)
  }

  showError() {
    if (!this.hasButtonTextTarget) return

    const originalText = this.buttonTextTarget.innerHTML

    // Show error message
    this.buttonTextTarget.innerHTML = '<i class="fas fa-times me-1"></i>נכשל'
    this.element.classList.remove('btn-outline-secondary')
    this.element.classList.add('btn-danger')

    // Revert after 2 seconds
    setTimeout(() => {
      this.buttonTextTarget.innerHTML = originalText
      this.element.classList.remove('btn-danger')
      this.element.classList.add('btn-outline-secondary')
    }, 2000)
  }
}
